import { ContentfulHomepage } from '@jbhi-fi/apis/src/contentful/types';
import { HomepageProps } from '../../views/Homepage/Homepage';
import { ToProductCarouselBaseOptions } from './CarouselTransformer/CarouselTransformer';
import { TakeoverBlockTransformer } from './TakeoverBlockTransformer';
import { ListingBlockTransformer } from './ListingBlockTransformer';

export abstract class HomepageTransformer {
  static toHomepageProps = (entry: ContentfulHomepage, options: ToProductCarouselBaseOptions = {}): HomepageProps => {
    return {
      sections: entry.fields?.sections ?? [],
      takeoverBlock: entry.fields?.saleTakeover?.fields
        ? TakeoverBlockTransformer.toTakeoverBlockProps(entry.fields?.saleTakeover, options)
        : undefined,
      categoryListingBlock: ListingBlockTransformer.toListingBlockProps(entry.fields?.categoryListingBlock, options),
    };
  };
}
